import * as React from "react";

import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import { JobCareer } from "../../../../domain/model/job_career";
import { Project } from "../../../../domain/model/project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import { TBreadcrumbItem } from "../../../type/common";
import ClientScoutCustomerMainScoutThirdForm from "./client_scout_customer_third/client_scout_customer_main_scout_third_form";

interface IProps {
  projects: Project[];
  jobCareers: JobCareer[];
  defaultText: string;
  handleCreateScout: (values: any) => void;
  handlePreviousStep: (values: any) => void;
}

const ClientScoutCustomerThirdComponent: React.FC<IProps> = (props) => {
  const { projects, jobCareers, handleCreateScout, handlePreviousStep, defaultText } = props;

  const clientScoutCustomerListMainScoutThirdParams = {
    projects,
    jobCareers,
    handlePreviousStep,
    defaultText,
  };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    { text: `最終確認` },
  ];

  return (
    <React.Fragment>
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
        {/* <PageTopInfo
                    information={`「スカウト」クリックすると選択したプロとメッセージルームが作成されます。`}
                    subInformation={`法人担当者様はそこからメッセージを送信して、必要に応じて面談調整を行ってください。`}
                /> */}
        <ClientScoutCustomerMainScoutThirdForm
          {...clientScoutCustomerListMainScoutThirdParams}
          onSubmit={handleCreateScout}
        />
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientScoutCustomerThirdComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_third.tsx